export default __webpack_public_path__ + "static/glamour_uk-dcbf8d11d32a6beeb8cb08daaeefd6c8.png";